import CompanyWorkDetailContent from "../../features/companyWork/widgets/CompanyWorkDetailContent";

function CompanyViewingDetailScreen() {
  return <CompanyWorkDetailContent kind="viewing" />;
}

export default CompanyViewingDetailScreen;
